const megaMenu = function(){
  const menuElements = document.getElementsByClassName("js-header-menu-item");
  const subMenuContainerElement = document.getElementById("submenu-container");
  const headerBottomElement = document.getElementById("header-bottom");
  const subMenuContentElements = document.getElementsByClassName("js-submenu-content");
  const subMenuBackBtnElements = document.getElementsByClassName("js-header-submenu-back");
  const checkboxElement = document.getElementById("mobile-menu-checkbox");
  const blurEffectElementsMobile = document.getElementsByClassName("js-blur-effect-mobile");
  const blurEffectElementsDesktop = document.getElementsByClassName("js-blur-effect-desktop");
  const mobileMenuItemElements = document.getElementsByClassName("js-mobile-menu-item");
  const megaMenuWrapper = document.getElementById("mega-menu-wrapper");
  const menuEffectLayer = document.getElementById("menu-effect-layer");
  const promoBarMobile = document.getElementById("promo-bar-mobile");
  const topGeoIpElement = document.getElementById("mobile-geo-ip");
  const subMenuSections = subMenuContainerElement.querySelectorAll('.shopify-section');
  if (Shopify.designMode) {
    subMenuSections.forEach(section => {
      section.removeAttribute('data-shopify-editor-section')
    })
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      if (section.querySelector('.header-submenu__content'))  section.removeAttribute('data-shopify-editor-section');
    });
  }
  megaMenuWrapper.appendChild(subMenuContainerElement);
  if (promoBarMobile) promoBarMobile.style.display = "block"
  if (topGeoIpElement) topGeoIpElement.style.display = "block"

  const backgroundEffectDesktop = function (state = 0) {
    if( state === 0 ) {
      for (let element of blurEffectElementsDesktop) {
        element.classList.remove("blur-effect")
      }
      menuEffectLayer.classList.remove("is-open")
    } else {
      for (let element of blurEffectElementsDesktop) {
        element.classList.add("blur-effect")
      }
      menuEffectLayer.classList.add("is-open")
    }
  }

  const backgroundEffectMobile = function (state = 0) {
    if( state === 0 ) {
      for (let element of blurEffectElementsMobile) {
        element.classList.remove("blur-effect")
      }
      menuEffectLayer.classList.remove("is-open")
    } else {
      for (let element of blurEffectElementsMobile) {
        element.classList.add("blur-effect")
      }
      menuEffectLayer.classList.add("is-open")
    }
  }

  let hoverTimeout;

  for (let element of menuElements) {

    element.addEventListener("mouseover", event => {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        let contentId = element.getAttribute("data-content-id");
        let contentFound = false;
        let isSimpleItem = false;

        if (element.classList.contains("is-simple-item")) {
          isSimpleItem = true;
        }
        if (!contentId) {
          backgroundEffectDesktop(0);
          return;
        }

        for (let _element of subMenuContentElements) {
          let currentContentId = _element.getAttribute("data-content-id");

          if (currentContentId === contentId) {
            _element.classList.add("is-open");
            contentFound = true;
          } else {
            _element.classList.remove("is-open");
          }
        }

        if (!contentFound) {
          subMenuContainerElement.classList.remove("is-open");
          megaMenuWrapper.classList.remove("is-simple");
          for (let _element of menuElements) {
            _element.classList.remove("is-hover");
          }
          backgroundEffectDesktop(0);
          return;
        }

        for (let _element of menuElements) {
          _element.classList.remove("is-hover");
        }

        element.classList.add("is-hover");
        subMenuContainerElement.classList.add("is-open");

        if (!isSimpleItem) {
          subMenuContainerElement.classList.remove("is-simple");
          megaMenuWrapper.classList.remove("is-simple");
        } else {
          subMenuContainerElement.classList.add("is-simple");
          megaMenuWrapper.classList.add("is-simple");
        }
      }, 200);
    })
  }

  headerBottomElement.addEventListener("mouseleave", event => {
    clearTimeout(hoverTimeout);

    if( subMenuContainerElement.matches(':hover') ) return

    for (let element of menuElements) {
      element.classList.remove('is-hover')
    }

    subMenuContainerElement.classList.remove("is-open")
    megaMenuWrapper.classList.remove("is-simple")

    for (let element of subMenuContentElements) {
      element.classList.remove("is-open")
    }

    backgroundEffectDesktop(0)
    subMenuContainerElement.classList.remove("is-simple")
  })

  subMenuContainerElement.addEventListener("mouseleave", event => {
    subMenuContainerElement.classList.remove("is-open")
    megaMenuWrapper.classList.remove("is-simple")

    for (let element of menuElements) {
      element.classList.remove('is-hover')
    }

    for (let element of subMenuContentElements) {
      element.classList.remove("is-open")
    }

    backgroundEffectDesktop(0)
    subMenuContainerElement.classList.remove("is-simple")
  })


  checkboxElement.addEventListener("change", ( event ) => {
    if( event.target.checked ) {
      document.documentElement.classList.add('is-mob-open')
      document.body.classList.add('is-mob-open')
      backgroundEffectMobile(1)
    } else {
      document.documentElement.classList.remove('is-mob-open')
      document.body.classList.remove('is-mob-open')

      for (let element of subMenuContentElements) {
        element.classList.remove("is-open")
      }

      subMenuContainerElement.classList.remove("is-open")
      megaMenuWrapper.classList.remove("is-simple")
      backgroundEffectMobile(0)
    }
  })


  for (let element of mobileMenuItemElements) {

    element.addEventListener("click", ( event ) => {
      let contentId = element.getAttribute("data-content-id")
      let contentFound = false

      for (let _element of subMenuContentElements) {
        if( contentId === _element.getAttribute("data-content-id") ) {
          _element.classList.add("is-open")
          contentFound = true
        }
      }

      if( contentFound ) {
        backgroundEffectDesktop(1)
        subMenuContainerElement.classList.add("is-open")
        event.preventDefault()
        return false
      }
    })
  }


  for (let element of subMenuBackBtnElements) {
    element.addEventListener("click", event => {
      subMenuContainerElement.classList.remove('is-open')

      for (let element of subMenuContentElements) {
        element.classList.remove("is-open")
      }
    })
  }

  window.onscroll = function(e) {
    if( this.oldScroll < this.scrollY && window.screen.width > 992) {
      for (let element of menuElements) {
        element.classList.remove('is-hover')
      }

      subMenuContainerElement.classList.remove("is-open")
      megaMenuWrapper.classList.remove("is-simple")
      backgroundEffectDesktop(0)
    }
    this.oldScroll = this.scrollY;
  }

}
megaMenu()

